module.exports = __webpack_public_path__ + "img/05tab-bingo.4e21a79f.png";